import {SVGProps} from "types/SVG";

export const DamageTop = ({alt, className}: SVGProps) => (
    <svg width="165" height="165" viewBox="0 0 165 165" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <title>{alt}</title>
        <g clip-path="url(#clip0_3545_20793)">
            <path d="M0.00108337 108.768L165.406 108.768V-0.000434875L0.00108337 -0.000434875V108.768Z"
                  fill="url(#paint0_linear_3545_20793)"/>
            <path d="M165.405 108.24H0V165.435H165.405V108.24Z" fill="url(#paint1_linear_3545_20793)"/>
            <mask id="mask0_3545_20793" maskUnits="userSpaceOnUse" x="0" y="0" width="166"
                  height="166">
                <path d="M165.405 0.0292969H0V165.434H165.405V0.0292969Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_3545_20793)">
                <path
                    d="M-176.503 130.535L-105.848 130.462L42.1078 132.063L114.59 134.303L125.495 128.37V81.4772L-190.053 78.8867L-176.503 130.535Z"
                    fill="#2C3E54"/>
                <path
                    d="M53.9581 60.1582L42.8903 60.2444C42.8903 60.2444 35.4964 61.216 35.7219 61.2894C35.9456 61.3645 38.1914 86.2667 33.9949 125.638L31.7949 132.063H42.1074C42.1074 132.063 40.7856 106.732 56.6073 91.576C58.3929 89.8655 60.7066 88.8059 63.1651 88.5474C68.2563 88.012 78.4551 87.5042 92.2088 89.6125C94.7204 89.9975 97.0249 91.2314 98.7464 93.1014C103.027 97.747 110.856 108.027 114.592 124.217V134.306H124.147L129.649 133.372L138.576 134.306C140.592 134.306 142.495 133.394 143.769 131.832C145.841 129.293 149.092 125.06 151.834 120.383L151.457 113.354L151.834 91.7924L154.124 77.2412L157.112 76.0624C157.112 76.0624 153.283 73.2372 147.858 72.1005L53.9599 60.1619L53.9581 60.1582Z"
                    fill="url(#paint2_linear_3545_20793)"/>
                <path
                    d="M132.535 81.8451C130.093 82.8223 128.861 84.8188 127.198 86.8336C126.548 87.6238 127.039 89.7871 126.324 90.6084C125.121 91.9853 123.614 91.1713 121.84 92.3593C120.976 92.9368 118.921 93.2503 117.766 93.7086C117.689 93.7398 117.625 93.7728 117.559 93.8223C116.492 94.6289 115.01 97.2249 113.936 98.2113C111.802 100.169 109.74 101.669 107.147 103.163C106.753 103.39 106.61 103.884 106.836 104.28C109.796 109.44 112.691 116.033 114.569 124.116C114.583 124.18 114.591 124.248 114.591 124.314V133.481C114.591 133.936 114.959 134.304 115.414 134.304H123.908L129.648 133.371L138.182 134.304C140.446 134.304 142.589 133.29 144.014 131.53C146.06 129.002 149.107 124.998 151.717 120.58C151.793 120.451 151.833 120.303 151.833 120.154L151.285 112.999L151.833 91.7909L151.875 91.5214C144.687 87.4863 140.129 78.5909 132.535 81.8469V81.8451Z"
                    fill="url(#paint3_linear_3545_20793)"/>
                <path
                    d="M157.111 76.0587C157.111 76.0587 153.281 73.2335 147.856 72.0969L53.9581 60.1582L42.8903 60.2444C42.8903 60.2444 35.4964 61.216 35.7219 61.2894C35.9456 61.3645 38.1914 86.2667 33.9949 125.638L31.7949 131.237L42.1074 132.063C42.1074 132.063 40.7856 106.732 56.6073 91.576C58.3929 89.8655 60.7066 88.8059 63.1651 88.5474C68.2563 88.012 78.4551 87.5042 92.2088 89.6125C94.7204 89.9975 97.0249 91.2314 98.7464 93.1014C100.778 95.3069 103.61 98.7994 106.424 103.575C110.76 101.163 114.016 98.132 116.423 95.2317C116.977 94.9952 117.463 93.9392 117.954 93.6734C120.165 92.4762 126.378 91.1855 126.459 90.5824C126.723 88.6409 127.312 86.9505 128.373 85.3867C129.365 83.9274 131.136 82.5689 132.533 81.8484C139.875 78.0589 144.684 87.4877 151.873 91.5229L154.12 77.2412L157.109 76.0624L157.111 76.0587Z"
                    fill="#2C3E54"/>
                <path
                    d="M56.6056 91.5763C58.3913 89.8658 60.7049 88.8061 63.1634 88.5476C68.2546 88.0123 78.4534 87.5044 92.2071 89.6128C94.7188 89.9978 97.0233 91.2316 98.7448 93.1016C100.776 95.3071 103.609 98.7996 106.423 103.575C110.759 101.163 114.015 98.1323 116.422 95.2319C116.975 94.9954 117.461 93.9394 117.953 93.6736C120.164 92.4764 126.377 91.1858 126.457 90.5826C126.721 88.6411 127.31 86.9508 128.371 85.3869C129.363 83.9276 131.134 82.5691 132.531 81.8486C137.468 79.3003 140.416 83.3978 144.556 87.1433C146.573 88.9693 149.515 90.2013 151.871 91.5231L154.119 77.2414L157.107 76.0626C157.107 76.0626 153.277 73.2374 147.852 72.1008L53.9546 60.1621L42.8868 60.2483C42.8868 60.2483 37.4088 61.2199 37.6324 61.2933C37.7168 61.3208 38.7343 70.5241 38.7343 70.5241C38.7343 70.5241 41.0791 71.6956 41.1194 72.9973C41.2129 76.0113 39.8086 78.3671 39.5263 82.4793C38.7581 93.5856 38.1329 109.55 36.4188 125.643L34.2188 132.069H42.1039C42.1039 132.069 40.7821 106.738 56.6038 91.5818L56.6056 91.5763Z"
                    fill="url(#paint4_linear_3545_20793)"/>
                <path
                    d="M99.875 68.1932C99.875 68.1932 110.602 75.6237 119.613 80.0677L121.714 80.6599L123.034 78.7587L144.561 87.1407C144.561 87.1407 147.804 81.3584 148.587 77.4442L133.731 73.7996L99.875 68.1914V68.1932Z"
                    fill="#4B6C8C"/>
                <path
                    d="M89.7475 60.1371L114.395 62.8156C125.978 64.0751 137.28 67.2101 147.857 72.0977C147.857 72.0977 142.987 73.6634 133.731 73.7991C133.731 73.7991 98.047 67.9819 73.8507 66.3961C70.9027 66.2036 68.0335 65.4427 65.3678 64.1741C62.528 62.8229 58.3755 61.1051 53.959 60.1591L68.8383 59.4807C75.8141 59.1636 82.8046 59.3817 89.7475 60.1371Z"
                    fill="url(#paint5_linear_3545_20793)"/>
                <path
                    d="M83.2044 83.4244C83.2044 83.4244 71.2639 79.7871 64.8912 79.7871C54.1241 79.7871 45.0729 94.1054 41.2742 108.039C40.7792 109.852 40.957 113.211 40.6802 116.76C40.6454 117.196 39.373 126.09 39.373 126.09C39.373 126.09 41.694 125.386 42.2239 125.932C43.6795 117.407 48.0722 99.7576 56.6082 91.5791C58.3939 89.8686 60.7076 88.8089 63.166 88.5504C68.2572 88.0151 78.4561 87.5073 92.2097 89.6156C93.8707 89.8704 95.4382 90.5029 96.8095 91.4398C97.5594 88.2039 94.7635 84.3246 94.7635 84.3246L83.2062 83.4281L83.2044 83.4244Z"
                    fill="#7196B5"/>
                <path
                    d="M157.11 76.0586L153.819 77.1531L151.832 91.7886L151.324 101.634C151.324 101.634 156.291 101.844 156.995 98.8139L157.11 76.0586Z"
                    fill="#547B9B"/>
                <path
                    d="M133.253 91.7637C133.253 91.7637 144.765 95.2085 151.832 91.947L151.455 113.353C151.455 113.353 139.382 114.464 130.016 110.288L132.126 92.6583L133.251 91.7637H133.253Z"
                    fill="url(#paint6_linear_3545_20793)"/>
                <path
                    d="M-49.5664 117.082L-49.1227 124.406L33.9933 125.636L34.2023 124.201L32.8199 119.592L7.1881 117.183L-49.5664 117.082Z"
                    fill="#7196B5"/>
                <path
                    d="M-185.562 29.4045L-183.663 31.3038L-137.722 33.0308L35.7208 61.2898L42.8892 60.2448L48.9813 56.8678L-13.022 25.7781L-21.4645 25.8203L-26.4567 22.359C-26.4567 22.359 -127.446 15.935 -185.562 29.4063V29.4045Z"
                    fill="#2C3E54"/>
                <path d="M-50.1191 103.852L-49.1236 113.141L34.8595 116.7L-50.1191 103.852Z"
                      fill="url(#paint7_linear_3545_20793)"/>
                <path
                    d="M-49.5665 117.082L-49.1247 113.143L34.8585 116.701L34.2021 124.201C29.4831 123.939 24.8283 122.975 20.3935 121.339L17.1613 120.148C15.35 119.48 13.4433 119.108 11.5128 119.046L-49.5684 117.082H-49.5665Z"
                    fill="url(#paint8_linear_3545_20793)"/>
                <path d="M-49.1216 124.406L-49.9668 131.3L42.1087 132.062L42.8365 125.636L-49.1216 124.406Z"
                      fill="#2C3E54"/>
                <path
                    d="M-53.0352 61.6211L4.93664 64.4884C10.8051 64.7781 16.6865 64.4407 22.4816 63.4801L32.9756 61.7421C24.689 55.3419 10.796 47.0662 -0.447861 40.6954C-11.8017 34.2622 -24.4865 30.5369 -37.5142 29.7669L-56.4434 28.6504L-53.037 61.6211H-53.0352Z"
                    fill="#4B6C8C"/>
                <path
                    d="M61.6478 60.0602C61.6478 60.0602 33.6748 40.1025 1.07261 27.4727C1.07261 27.4727 -6.04256 28.206 -9.02539 29.834C-9.02539 29.834 22.7188 43.8443 42.8909 60.2435L61.6478 60.0583V60.0602Z"
                    fill="#4B6C8C"/>
                <g opacity="0.25">
                    <path
                        d="M53.6673 60.1376C43.9158 53.9299 20.2804 39.6739 -6.86206 28.9746C-7.68522 29.2276 -8.43689 29.5118 -9.02539 29.8326C-9.02539 29.8326 22.7188 43.8429 42.8909 60.2421L53.6673 60.1358V60.1376Z"
                        fill="white"/>
                </g>
                <path
                    d="M-26.457 22.3574L-21.4649 25.8188C-21.4649 25.8188 -11.7262 28.6953 -9.02753 29.8338C-6.0447 28.2076 1.07047 27.4724 1.07047 27.4724C1.07047 27.4724 -9.5482 23.0009 -26.457 22.3574Z"
                    fill="url(#paint9_linear_3545_20793)"/>
                <path
                    d="M35.7208 61.2891L22.4823 63.4817C16.6871 64.4424 10.8039 64.7797 4.93727 64.4901L-53.0254 61.6227L-53.0199 61.7107C-50.5247 76.2619 -49.6282 93.6034 -49.3056 103.976L34.8591 116.702C37.8493 82.5429 35.9279 61.3587 35.7208 61.2909V61.2891Z"
                    fill="url(#paint10_linear_3545_20793)"/>
                <path
                    d="M-1.45508 59.4774L0.0152553 54.1057C0.429589 52.5914 1.63776 51.4364 3.16492 51.0716C4.72326 50.6994 6.89942 50.3254 9.39826 50.3107C11.4883 50.2979 13.5251 50.9872 15.1989 52.2376L16.2513 53.0241C18.7226 54.8721 20.0059 57.9081 19.6081 60.9679L-1.45508 59.4774Z"
                    fill="url(#paint11_linear_3545_20793)"/>
                <path
                    d="M14.3667 70.3557L18.4165 70.6783C19.6687 70.7773 20.9062 70.3612 21.8412 69.527L22.2427 69.1695C22.7267 68.7387 23.0365 68.1447 23.1154 67.503C23.1924 66.8724 23.0439 66.2362 22.6974 65.7045L19.61 60.969L-1.45312 59.4785L1.76804 64.1902L11.9174 64.8337L12.5499 68.6837C12.6984 69.593 13.4482 70.2824 14.3667 70.3557Z"
                    fill="#7196B5"/>
                <path
                    d="M18.8914 63.4127L22.8257 68.4214C22.976 68.1372 23.075 67.8256 23.1154 67.5011C23.1924 66.8704 23.0439 66.2342 22.6974 65.7026L19.61 60.9671L-1.45312 59.4766L15.5144 61.5116C16.8472 61.6711 18.0627 62.3549 18.8932 63.4109L18.8914 63.4127Z"
                    fill="#2C3E54"/>
                <path
                    d="M-37.5121 29.7668C-24.4844 30.5368 -11.7996 34.2621 -0.445732 40.6953C10.7743 47.0533 24.6343 55.3088 32.9264 61.7035L35.7223 61.2873C27.8628 54.7148 12.4499 45.506 0.201435 38.5668C-11.1524 32.1336 -23.8372 28.4083 -36.8649 27.6383L-56.6777 26.4668L-56.4467 28.6466L-37.5139 29.7668H-37.5121Z"
                    fill="#93B8D1"/>
                <path
                    d="M78.9914 156.737C95.8034 156.737 109.432 143.108 109.432 126.296C109.432 109.484 95.8034 95.8555 78.9914 95.8555C62.1795 95.8555 48.5508 109.484 48.5508 126.296C48.5508 143.108 62.1795 156.737 78.9914 156.737Z"
                    fill="#4B6C8C"/>
                <path
                    d="M78.9898 149.946C92.0514 149.946 102.64 139.358 102.64 126.296C102.64 113.235 92.0514 102.646 78.9898 102.646C65.9283 102.646 55.3398 113.235 55.3398 126.296C55.3398 139.358 65.9283 149.946 78.9898 149.946Z"
                    fill="url(#paint12_linear_3545_20793)"/>
                <path
                    d="M78.9917 147.796C90.8655 147.796 100.491 138.17 100.491 126.296C100.491 114.423 90.8655 104.797 78.9917 104.797C67.1178 104.797 57.4922 114.423 57.4922 126.296C57.4922 138.17 67.1178 147.796 78.9917 147.796Z"
                    fill="#37556D"/>
                <path
                    d="M78.9899 133.267C82.8395 133.267 85.9602 130.146 85.9602 126.297C85.9602 122.447 82.8395 119.326 78.9899 119.326C75.1403 119.326 72.0195 122.447 72.0195 126.297C72.0195 130.146 75.1403 133.267 78.9899 133.267Z"
                    fill="#4B6C8C"/>
                <path
                    d="M118.664 79.1122L107.244 78.5879L99.326 82.1501L97.3386 81.1087L92.8414 84.1851L90.1758 89.3129L92.2071 89.6117L101.141 91.5441L101.227 83.6369L108.722 81.3324L117.377 80.0124L118.664 79.1122Z"
                    fill="url(#paint13_linear_3545_20793)"/>
                <path
                    d="M119.613 80.0633L108.193 79.5371L100.277 83.0993L98.2896 82.0579L94.7604 84.3203L92.1992 89.6113L95.0959 92.7903L102.129 95.3331L102.178 84.5861L109.671 82.2816L121.71 80.6554L119.613 80.0633Z"
                    fill="url(#paint14_linear_3545_20793)"/>
                <path
                    d="M102.955 89.509L100.764 87.375L99.406 87.3823L96.8906 92.7907L97.5598 95.4032C97.7266 95.6177 103.753 96.9303 103.923 97.1558C107.671 102.089 113.374 113.9 116.384 124.214C116.32 129.234 116.384 134.303 116.384 134.303C116.384 134.303 122.838 132.035 122.865 129.973C123.041 116.186 116.372 102.714 114.208 98.628C113.788 97.8342 113.578 97.1943 113.578 97.1943L102.955 89.509Z"
                    fill="#2C3E54"/>
                <path
                    d="M102.997 89.5084L102.178 84.5859L97.611 87.3799L95.0957 92.7883L95.7649 95.4008C95.9317 95.6153 101.958 96.9279 102.128 97.1534C105.876 102.087 111.579 113.897 114.59 124.212C114.525 129.231 114.59 134.3 114.59 134.3C114.59 134.3 121.043 132.033 121.07 129.97C121.281 113.503 113.576 97.1919 113.576 97.1919L102.997 89.5066V89.5084Z"
                    fill="#7196B5"/>
                <path
                    d="M101.488 69.3008C101.488 69.3008 102.608 72.2414 107.799 75.3416C109.309 76.2436 117.451 79.9616 117.451 79.9616L119.614 80.0661L118.826 74.4176L121.384 71.9133L117.561 71.1983C112.882 70.3238 108.154 69.7298 103.402 69.4236L101.488 69.3008Z"
                    fill="#2C3E54"/>
                <path
                    d="M101.488 69.3007C101.488 69.3007 110.594 75.6165 119.603 80.0605H119.616L118.826 74.4157L121.384 71.9113L117.561 71.1963C112.882 70.3218 108.154 69.7278 103.402 69.4217L101.488 69.2988V69.3007Z"
                    fill="#61829E"/>
                <path
                    d="M105.703 102.877L105.17 101.883L110.144 100.253L113.583 97.1953L113.777 97.6408L110.663 101.043L105.703 102.877Z"
                    fill="#4B6C8C"/>
                <path
                    d="M131.273 81.9688L126.747 86.5759L126.184 90.2627L117.186 93.2621L113.783 97.6364C113.851 97.8179 114.038 98.2542 114.214 98.6319L117.74 94.0449L127.007 90.9557L127.61 87.0012L131.895 82.2126L131.273 81.9688Z"
                    fill="url(#paint15_linear_3545_20793)"/>
                <path
                    d="M151.455 113.351L151.833 115.171L148.083 123.025C148.083 123.025 138.662 122.36 132.672 119.437C131.908 119.063 131.428 117.914 131.508 116.697L129.541 109.482L151.455 113.353V113.351Z"
                    fill="url(#paint16_linear_3545_20793)"/>
                <path
                    d="M131.757 114.874C131.665 114.83 131.374 114.738 130.939 114.611L131.508 116.694C131.429 117.911 131.907 119.063 132.672 119.435C138.661 122.359 148.083 123.023 148.083 123.023L149.291 120.491C145.133 119.44 136.251 117.064 131.757 114.872V114.874Z"
                    fill="#86B4EA"/>
                <path
                    d="M133.254 91.677L132.631 91.5193C131.666 91.2773 130.761 92.6761 130.445 94.8963L130.372 101.94L128.357 109.611C127.978 112.278 128.96 116.968 132.671 119.437L131.756 114.874C130.986 113.281 130.191 111.987 130.528 109.611L133.366 102.745C133.366 102.745 133.104 91.9318 133.252 91.6751L133.254 91.677Z"
                    fill="#2C3E54"/>
                <path
                    d="M144.165 128.285L131.864 127.393L122.878 128.285H114.59V133.479C114.59 133.934 114.958 134.302 115.413 134.302H123.907L129.647 133.369L138.181 134.302C140.445 134.302 142.589 133.289 144.013 131.529C144.869 130.473 145.903 129.145 147.003 127.651C146.125 128.064 145.159 128.287 144.163 128.287L144.165 128.285Z"
                    fill="#7196B5"/>
                <path d="M133.253 91.7637L133.184 94.5797L146.404 93.3128L133.253 91.7637Z" fill="#4B6C8C"/>
                <path d="M133.703 73.7891L133.574 74.7131L148.586 77.4447L133.703 73.7891Z"
                      fill="url(#paint17_linear_3545_20793)"/>
                <path
                    d="M101.488 69.3008L115.814 69.6858L130.84 73.1379L129.667 73.6989L120.366 72.9124L101.488 69.3008Z"
                    fill="url(#paint18_linear_3545_20793)"/>
                <path d="M130.374 101.939L127.646 99.2773L128.36 109.61L130.374 101.939Z" fill="#F09063"/>
            </g>
            <path
                d="M37.2227 62.9244L37.637 61.2891L103.564 66.8826L133.731 73.7979L121.382 71.9132L110.134 70.0506L101.488 69.3007L37.2227 62.9244Z"
                fill="#2C3E54"/>
            <path
                d="M64.4361 73.6856C67.5949 74.0816 98.2886 82.0584 98.2886 82.0584L90.6436 78.2762L62.909 71.3884L38.7383 70.5176L41.1234 72.9907C41.1234 72.9907 61.2773 73.2896 64.4361 73.6856Z"
                fill="url(#paint19_linear_3545_20793)"/>
            <path
                d="M62.9121 71.3887L64.4393 73.684C67.5981 74.08 98.2918 82.0568 98.2918 82.0568L95.5711 79.2445L88.5659 75.7868L76.6071 74.6832L62.9121 71.3887Z"
                fill="url(#paint20_linear_3545_20793)"/>
            <path
                d="M129.27 75.8722L133.586 74.7172L133.705 73.7895L130.843 73.1387L124.641 76.094L126.333 76.963L123.033 78.7578L129.234 78.8183L129.27 75.8722Z"
                fill="url(#paint21_linear_3545_20793)"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear_3545_20793" x1="82.7046" y1="-12.9163" x2="82.7046" y2="77.2507"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#ECFFFF"/>
                <stop offset="0.46" stop-color="#F0FCFF"/>
                <stop offset="1" stop-color="#FFF4FF"/>
            </linearGradient>
            <linearGradient id="paint1_linear_3545_20793" x1="82.7035" y1="227.79" x2="82.7035" y2="84.0439"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#ECFFFF"/>
                <stop offset="0.3" stop-color="#E8FAFF"/>
                <stop offset="0.66" stop-color="#DEEBFF"/>
                <stop offset="1" stop-color="#CFD7FF"/>
            </linearGradient>
            <linearGradient id="paint2_linear_3545_20793" x1="94.4528" y1="148.576" x2="94.4528" y2="0.644535"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint3_linear_3545_20793" x1="108.262" y1="93.6793" x2="191.371" y2="156.337"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint4_linear_3545_20793" x1="95.6666" y1="145.905" x2="95.6666" y2="2.44144"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint5_linear_3545_20793" x1="162.562" y1="66.5702" x2="-26.792" y2="66.5702"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint6_linear_3545_20793" x1="118.284" y1="102.624" x2="245.477" y2="102.624"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint7_linear_3545_20793" x1="-50.1191" y1="110.276" x2="34.8595" y2="110.276"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint8_linear_3545_20793" x1="-7.35402" y1="108.161" x2="-7.35402" y2="154.198"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint9_linear_3545_20793" x1="5.6318" y1="26.0956" x2="-100.089" y2="26.0956"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint10_linear_3545_20793" x1="-53.0254" y1="88.9944" x2="36.5183" y2="88.9944"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint11_linear_3545_20793" x1="-1.45508" y1="55.6384" x2="19.6814" y2="55.6384"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint12_linear_3545_20793" x1="55.3398" y1="126.296" x2="102.64" y2="126.296"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint13_linear_3545_20793" x1="108.771" y1="83.3821" x2="56.8824" y2="99.4164"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.03" stop-color="#C45519"/>
                <stop offset="0.08" stop-color="#B0643E"/>
                <stop offset="0.14" stop-color="#9F725E"/>
                <stop offset="0.2" stop-color="#907D79"/>
                <stop offset="0.27" stop-color="#85868F"/>
                <stop offset="0.35" stop-color="#7B8DA0"/>
                <stop offset="0.46" stop-color="#7592AC"/>
                <stop offset="0.6" stop-color="#7295B3"/>
                <stop offset="0.99" stop-color="#7196B5"/>
            </linearGradient>
            <linearGradient id="paint14_linear_3545_20793" x1="120.926" y1="80.5363" x2="71.5614" y2="99.9788"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint15_linear_3545_20793" x1="119.258" y1="92.1107" x2="204.35" y2="47.9238"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint16_linear_3545_20793" x1="128.923" y1="116.253" x2="145.88" y2="116.253"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.04" stop-color="#86ABEE"/>
                <stop offset="0.17" stop-color="#A0C0F4"/>
                <stop offset="0.31" stop-color="#B4D0F9"/>
                <stop offset="0.47" stop-color="#C2DCFC"/>
                <stop offset="0.67" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint17_linear_3545_20793" x1="101.311" y1="71.4241" x2="146.554" y2="76.1871"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint18_linear_3545_20793" x1="101.51" y1="69.5538" x2="147.298" y2="74.3736"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint19_linear_3545_20793" x1="104.078" y1="76.1166" x2="51.9346" y2="76.3696"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint20_linear_3545_20793" x1="104.081" y1="76.61" x2="51.9396" y2="76.8612"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint21_linear_3545_20793" x1="123.033" y1="75.9785" x2="133.705" y2="75.9785"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <clipPath id="clip0_3545_20793">
                <rect width="165" height="165" rx="8" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);
